import { render, staticRenderFns } from "./TplBasicTable.vue?vue&type=template&id=05db01e1&scoped=true&"
import script from "./TplBasicTable.vue?vue&type=script&lang=js&"
export * from "./TplBasicTable.vue?vue&type=script&lang=js&"
import style0 from "./TplBasicTable.vue?vue&type=style&index=0&id=05db01e1&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05db01e1",
  null
  
)

export default component.exports